import { render, staticRenderFns } from "./EditMemberModal.vue?vue&type=template&id=6abb6148&scoped=true&"
import script from "./EditMemberModal.vue?vue&type=script&lang=ts&"
export * from "./EditMemberModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditMemberModal.vue?vue&type=style&index=0&id=6abb6148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb6148",
  null
  
)

export default component.exports